module.exports = __webpack_public_path__ + "img/r-68.320ede20.jpg";